/**
* @ngdoc component
* @name common.component:itxConfirmDefaultStore
* @description
* Confirm if user wants to save the current country as default ones.
*/
(function() {
  'use strict';
  
   var itxConfirmDefaultStore = {
    bindings: {
      onAcceptSaveStore: '&',
      onRejectSaveStore: '&'
    },
    controller:   itxConfirmDefaultStoreCtrl,
    templateUrl: 'confirm-default-store.component.html'
  };

  itxConfirmDefaultStoreCtrl.$inject = [
    'ItxTranslateSvc'
  ];

  function itxConfirmDefaultStoreCtrl (
    ItxTranslateSvc
  ) {
    var _this = this;

    _this.$onInit = function () {
      _this.banner = 'LAST_GEOBLOCKING';
      _this.text = {
        title: ItxTranslateSvc.translate('home.askDefaultStore.areYouSure', inditex.iStoreJSON.countryName),
        acceptText: ItxTranslateSvc.translateCms('legacy.Messages_yes'),
        cancelText: ItxTranslateSvc.translateCms('legacy.Messages_no')
      };
    };

    _this.onAccept = function () {
      _this.accepted = true;
      _this.onAcceptSaveStore();
   
      setTimeout(function() {
          $('html').removeClass('new-interstitial');
      }, 800);

    }
    _this.onCancel =  function(){
      _this.rejected = true;
      _this.onRejectSaveStore();
     
      setTimeout(function() {
          $('html').removeClass('new-interstitial');
      }, 800);
    }

  }

  angular.module('itxApp.common')
  .component('itxConfirmDefaultStore',itxConfirmDefaultStore);

})();